<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2019-12-13 14:23:23
 * @LastEditTime: 2020-03-06 11:02:11
 -->
<template>
  <!-- 此组件用于选择使用哪种方式渲染组件 -->
  <component
    :is="curComponent"
    ref="common"
    :data="metaData"
    :is-delivery="isDelivery"
    :preview-handler="previewHandler"
    @iframeloaded="iframeloaded"
    @loadFail="loadFail"
    @loadingAction="loadingAction"
    @reGetData="startPreview"
    @getOriginData="startPreview"
  />
</template>
<script>
import coDoc from 'components/common/doc/index.vue'
import bsVideo from 'components/business/video/index.vue'
import bsAudio from 'components/business/audio/index.vue'
import bsLinkVideo from 'components/business/link/video/index.vue'
import bsLinkAudio from 'components/business/link/audio/index.vue'
import bsPic from 'components/business/pic/index.vue'
import bsOther from 'components/business/other/index.vue'
import { getPreviewType } from 'js/util/util'
import 'video.js/dist/video-js.css'
import Preview from 'js/preview/preview-sdk'
import _$ from 'js/api/getdata'

export default {
  components: {
    coDoc,
    bsVideo,
    bsAudio,
    bsLinkVideo,
    bsLinkAudio,
    bsPic,
    bsOther,
  },
  props: {
    isDelivery: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 当前使用的组件
      curComponent: '',
      metaData: {},
      previewHandler: null,
    }
  },
  methods: {
    /**
             * loading process中的操作
             * 目前ppt模式在loading中有本地打开（客户端）
             */
    loadingAction(type) {
      this.$emit('loadingAction', type)
    },
    /**
             * 预览失败时抛出的事件
             */
    loadFail(err) {
      this.$emit('loadFail', err)
    },
    /**
             * 开始预览
             */
    async startPreview(d = this.metaData) {
      try {
        const data = d
        this.metaData = d
        const componentName = this.swichComponent(data)
        if (!componentName) {
          return
        }
        this.curComponent = componentName
        this.$nextTick(() => {
          this.$refs.common.startPreview(data) // 用于切换文件后，loading等预处理
          if (componentName === 'bsOther') {
            return
          }
          this.urlPretreat(d)
        })
      } catch (e) {
        console.log(e, 'startPreview')
      }
    },
    /**
     * 预览流程说明
     * 1. urlPretreat 预览地址预处理，统一通过预览地址获取资源
     * 预览 method：setPreviewRouter ; url: /preview/router
     * 外链预览 method:  setDeliveryPreviewUrl; url:delivery/preview/router
     * 2. 转交 preview-sdk.js 查询文件是否转化完成  method: dispatchPreviewRouter
     * 3. 成功/失败调用每个预览组件的 previewDone/previewFail
     */
    async urlPretreat(d) {
      if (JSON.stringify(d) === '{}') return // 获取预览失败
      if (!this.isDelivery) {
        this.setPreviewRouter(d)
      } else {
        this.setDeliveryPreviewUrl(d)
      }
    },
    async setPreviewRouter(data) {
      const {
        neid, type, mime_type: mimeType, rev, file_extension: fileExtension,
        hash, download_url: downloadUrl, show_json: showJson, aid, uid, nsid,
        from, prefix_neid: prefixNeid,previewType,
      } = data
      const param = {
        neid,
        type,
        mime_type: mimeType, // no
        rev,
        file_extension: fileExtension,
        hash,
        wopisrc: downloadUrl,
        show_json: this.getJsonStr(showJson),
        aid, // no
        uid, // no
        nsid,
        from,
        prefix_neid: prefixNeid,
        previewType,
      }

      _$.getData('newPreviewUrl', param).then(({ data: backdata }) => {
        this.dispatchPreviewRouter(backdata)
      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.loadFail('noAccess')
        } else if (error.response && error.response.status === 409) {
          this.loadFail('lowSecret')
        } else {
          this.$refs.common.previewFail()
        }
      })
    },
    async setDeliveryPreviewUrl(data) {
      // 需要调研为空的参数
      const publicKey = localStorage.getItem('public_key')
      this.$jsEncrypt.setPublicKey(publicKey)
      if (data.folder_id.length > 32) {
        data.folder_id = data.folder_id.substring(5, data.folder_id.length)
      }
      const param = {
        folder_id: data.folder_id || '',
        neid: data.neid,
        nsid: data.nsid,
        path_type: data.path_type,
        token: data.token || '',
        password: this.$jsEncrypt.encrypt(data.password) || '',
        approver_op: '',
        show_json: '',
        previewType: data.previewType,
        aid: '',
        uid: '',
      }
      _$.getData('newDeliveryPreviewUrl', param).then(({ data: backdata }) => {
        this.dispatchPreviewRouter(backdata)
      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.loadFail('invalidLose')
        } else {
          this.$refs.common.previewFail()
        }
      })
    },
    getJsonStr(data) {
      let jsonStr
      try {
        jsonStr = JSON.parse(data)
      } catch (e) {
        jsonStr = data
      }
      return jsonStr
    },
    dispatchPreviewRouter(resData) {
      const vm = this
      // 初始化预览sdk
      if (this.previewHandler) {
        this.previewHandler.toggleSetInterval(false)
      }
      this.previewHandler = new Preview(vm.$refs.common.previewDone,
        vm.$refs.common.previewFail,
        vm.$refs.common.progressCallback)
      this.previewHandler.abortAll()
      this.previewHandler.before(resData)
    },
    /**
             * 用于选择使用哪种组件
             */
    swichComponent(data) {
      const cfg = {
        doc: 'coDoc',
        video: 'bsVideo',
        image: 'bsPic',
        audio: 'bsAudio',
        linkvideo: 'bsLinkVideo',
        linkaudio: 'bsLinkAudio',
        other: 'bsOther',
        dwg: 'coDoc',
        '3d': 'coDoc',
      }
      let type = getPreviewType(data)
      if (type === 'audio' || type === 'video') {
        if (this.isDelivery) {
          type = `link${type}`
        }
      }
      return cfg[type] || 'bsOther'
    },
    init() {
      if (this.$refs.common) {
        this.$refs.common.startPreview()
      }
    },
    /**
             * 加载完成函数
             */
    iframeloaded() {
      this.$emit('iframeloaded')
    },
  },
}
</script>
